import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { Union } from '../interfaces/union.interface';
import { ENVIRONMENT } from '../tokens/environment.token';

@Injectable({
	providedIn: 'root',
})
export class UnionService {
	private http = inject(HttpClient);
	private env = inject(ENVIRONMENT);

	fetchUnions(): Observable<Union[]> {
		return this.http
			.post(this.env.server + '/v2/machineMgmt/unions', {})
			.pipe(map((response: any) => response['unions']));
	}

	fetchUnionOnSerial(serial: string): Observable<Union | undefined> {
		const date = Math.floor(new Date().getTime() / 1000);
		return this.http
			.post(this.env.server + '/v2/machineMgmt/unions', {
				serials: [serial],
				from: date,
				to: date,
			})
			.pipe(
				map((response: any) =>
					response.unions?.find((union: Union) => union.serials?.includes(serial))
				)
			);
	}
}
